module.exports = __webpack_public_path__ + "static/logo-trust-bd15d4f8530684e2e1c97a98c8b975b5.png";